<script lang="ts">
  import { icons, type IconName } from './index';

  interface Props {
    name: IconName;
    class?: string;
    size?: number;
  }

  let { name, class: className = 'w-5 h-5', size }: Props = $props();

  const svg = $derived.by(() => {
    const raw = icons[name];
    if (!raw) return '';
    const sizeAttr = size ? ` width="${size}" height="${size}"` : '';
    return raw.replace('<svg ', `<svg class="${className}"${sizeAttr} `);
  });
</script>

{@html svg}
